import React from 'react';
import s from './BaseComp.scss';
import { TextFeedItem } from './TextFeedItem';
import { FeedInstance } from '../../models/feed';
import { linkHelper } from '../../utils/linkHelper';
import { LinkWrapper } from '.';

interface ItemProps {
    article: FeedInstance
}

/**
 * @component
 * Image Item in card
 * @param props {ItemProps} - props
 */
export const ImageFeedItem = (props: ItemProps) => {
    const { article } = props;
    // error message handler
    if (!article) {
        return null;
    }
    // If dont have images list here, use Text Component as plan B
    if (!article.images.length) {
        return TextFeedItem({ article });
    }
    // @render
    return (
        <div>
            <LinkWrapper className={s.imageComp} href={linkHelper(article.url)} title={article.title.replace('✎', '')}>
                <div className={s.coverBox}>
                    <img className={s.cover} src={article.images[0]} alt="" />
                </div>
                <p className={s.label}>{article.title.replace('✎', '')}</p>
            </LinkWrapper>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/BaseComp/ImageFeedItem.tsx